export default "__VITE_ASSET__DhXP1ovB__"